// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-98da49fa] {\n  text-align: right;\n  padding-top: 20px;\n}\n.box-card[data-v-98da49fa] {\n  width: 675px;\n}\n.address[data-v-98da49fa] {\n  width: 550px;\n}\n[data-v-98da49fa] .el-card__body {\n  padding: 0 15px 15px 0 !important;\n}", ""]);
// Exports
module.exports = exports;
